import { cn } from "@utils/tw"
import { DayPicker } from "react-day-picker"
import { Icon } from "./Icon"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({ className, classNames, ...props }: CalendarProps) {
  return (
    <DayPicker
      className={cn("p-3 type-ui-l text-fg space-y-4", className)}
      day-picker=""
      classNames={{
        months: "cal-months",
        month: "cal-month",
        caption: "cal-caption",
        caption_label: "cal-caption-label",
        nav: "cal-nav",
        button_previous: "cal-button-previous",
        button_next: "cal-button-next",
        day: "cal-day",
        day_button: "cal-day-button",
        selected: "cal-selected",
        day_today: "cal-day-today",
        day_outside: "cal-day-outside",
        day_disabled: "cal-day-disabled",
        day_range_middle: "cal-day-range-middle",
        day_hidden: "cal-day-hidden",
        // months: "flex flex-col relative",
        // month: "space-y-4",
        // caption: "h-[24px] type-ui-m",
        // caption_label: "h-[24px] type-ui-m pl-[5px] flex items-center font-bold",
        // nav: "flex items-center right-0 top-0 absolute gap-1",
        // // nav_button: cn("text-[red]", "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
        // button_previous: "size-[24px] inline-flex items-center justify-center hover:bg-bg-low rounded-sm",
        // button_next: "size-[24px] inline-flex items-center justify-center hover:bg-bg-low rounded-sm",
        // day: "h-6 w-6 p-[0.5px] text-center data-[disabled]:opacity-[0.1]",
        // day_button: "h-full w-full inline-flex items-center justify-center rounded-[8px] hover:bg-bg-low",
        // selected: "[&_button]:!bg-fg [&_button]:text-bg",
        // day_today: "bg-accent text-accent-foreground",
        // day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        // day_disabled: "text-muted-foreground opacity-50",
        // day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        // day_hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron({ orientation, size }) {
          if (orientation === "left") return <Icon name="chevronLeft" />
          if (orientation === "right") return <Icon name="chevronRight" />
          if (orientation === "up") return <Icon name="chevronUp" />
          return <Icon name="chevronDown" />
        },
      }}
      {...props}
    />
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
// const buttonVariants = tv({
//   base: "",
//   variants: {
//     variant: {
//       outline: "border border-muted-foreground",
//       ghost: "bg-transparent ",
//     },
//   },
// })
